import CustomerArea from '@/js/components/customer/CustomerArea';
import CustomerOrders from '@/js/components/customer/CustomerOrders';
import CustomerPersonalData from '@/js/components/customer/CustomerPersonalData';
import CustomerAddressBook from '@/js/components/customer/CustomerAddressBook';
import CustomerOrderDetails from '@/js/components/customer/CustomerOrderDetails';

const routes = [
    {
        path: '/customer',
        component: CustomerArea,
        beforeEnter: (to, from, next) => {
            window.store.commit('customerSetStoredData', ['orders', window.orders]);
            window.store.commit('customerSetStoredData', ['personalData', window.personalData]);
            window.store.commit('customerSetStoredData', ['address', window.address]);
            window.orders = window.personalData = window.address = null;
            next();
        },
        children: [
            {
                path: '/',
                redirect: 'my-orders',
            },
            {
                path: 'my-orders',
                name: 'customer.my-orders',
                component: CustomerOrders
            },
            {
                path: 'order/:code',
                name: 'customer.order-details',
                component: CustomerOrderDetails
            },
            {
                path: 'personal-data',
                name: 'customer.personal-data',
                component: CustomerPersonalData
            },
            {
                path: 'address-book',
                name: 'customer.address-book',
                component: CustomerAddressBook
            },
        ]
    }
];
export default routes;
